import type { Action } from '@reduxjs/toolkit'

/** The draft a wizard action is about: its `draftId`, or the id of the draft it carries. */
export const draftIdOf = (action: Action): string | undefined => {
  if (!action.type.startsWith('orderWizard/')) {
    return undefined
  }
  const payload = (action as Action & { payload?: { draftId?: unknown; draft?: { id?: unknown } } }).payload
  const id = payload?.draftId ?? payload?.draft?.id
  return typeof id === 'string' ? id : undefined
}
